//  Global Context
//  This component is created for manage global context

import React from "react"

export const GlobalStateContext = React.createContext()
export const GlobalDispatchContext = React.createContext()

const initialState = {
  bookToCall: false,
}

function reducer(state, action) {
  switch (action.type) {
    case "TOGGLE_MODAL": {
      return {
        ...state,
        bookToCall: !state.bookToCall,
      }
    }
    default:
      throw new Error("Bad Action Type")
  }
  
}

const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState)
  
  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  )
}

export default GlobalContextProvider